const TO_CODE = { RATEHAWK: "s1", HOTELRACK: "s2", DAHRTOURS: "s3" };
const FROM_CODE = { s1: "RATEHAWK", s2: "HOTELRACK", s3: "DAHRTOURS" };

const TO_SOURCE_CODE = {
  amadeus: "f1",
  aljazeera: "f2",
  tripjack: "f3",
  verteil: "f4",
  "air-arabia": "f5",
  "akasa-air": "f6",
  "fly-dubai": "f7",
  "ndc-portal": "f8",
  "travel-fusion": "f9",
};
const FROM_SOURCE_CODE = {
  f1: "amadeus",
  f2: "aljazeera",
  f3: "tripjack",
  f4: "verteil",
  f5: "air-arabia",
  f6: "akasa-air",
  f7: "fly-dubai",
  f8: "ndc-portal",
  f9: "travel-fusion",
};

export const toUrlVendor = (vendor) => {
  if (vendor === null || vendor === undefined || vendor === "") return vendor;
  return TO_CODE[vendor] || vendor;
};

export const fromUrlVendor = (code) => {
  if (code === null || code === undefined || code === "") return code;
  return FROM_CODE[code] || code;
};

export const toUrlSource = (source) => {
  if (source === null || source === undefined || source === "") return source;
  return TO_SOURCE_CODE[source] || source;
};

export const fromUrlSource = (code) => {
  if (code === null || code === undefined || code === "") return code;
  return FROM_SOURCE_CODE[code] || code;
};

const TO_EXCURSION_CODE = { rayna: "e1", parmar: "e2", emaar: "e3" , "Emaar" : "e4" , "dahrtours" : "e5" , "Dahrtours" : "e5", "DubaiPark" : "e6","HeliDubai" : "e7"};
const FROM_EXCURSION_CODE = { e1: "rayna", e2: "parmar", e3: "emaar" , "e4" : "Emaar" , "e5" : "dahrtours" , "e5" : "Dahrtours","e6" : "DubaiPark","e7":"HeliDubai"};

export const toUrlExcursionVendor = (vendor) => {
  if (vendor === null || vendor === undefined || vendor === "") return vendor;
  return TO_EXCURSION_CODE[vendor] || vendor;
};

export const fromUrlExcursionVendor = (code) => {
  if (code === null || code === undefined || code === "") return code;
  return FROM_EXCURSION_CODE[code] || code;
};
